var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExploreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#484B63"
    },
    d: "M507.474,376.159L507.474,376.159c-6.035,6.035-15.819,6.035-21.853,0L384.366,274.904   l21.853-21.853l101.254,101.254C513.509,360.34,513.509,370.124,507.474,376.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D5ED"
    },
    d: "M320.507,512H4c-2.209,0-4-1.791-4-4V60.66c0-2.209,1.791-4,4-4h316.507c2.209,0,4,1.791,4,4V508   C324.507,510.209,322.716,512,320.507,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF2C5C"
    },
    d: "M91.292,476.177H37.481c-2.209,0-4-1.791-4-4V313.288c0-2.209,1.791-4,4-4h53.811   c2.209,0,4,1.791,4,4v158.889C95.292,474.387,93.501,476.177,91.292,476.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD659"
    },
    d: "M188.129,476.177h-53.811c-2.209,0-4-1.791-4-4v-220.7c0-2.209,1.791-4,4-4h53.811   c2.209,0,4,1.791,4,4v220.7C192.129,474.387,190.338,476.177,188.129,476.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4FC6F5"
    },
    d: "M287.026,476.177h-53.811c-2.209,0-4-1.791-4-4V274.141c0-2.209,1.791-4,4-4h53.811   c2.209,0,4,1.791,4,4v198.036C291.026,474.387,289.235,476.177,287.026,476.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E62753"
    },
    d: "M64.386,309.288v166.889h26.905c2.209,0,4-1.791,4-4V313.288c0-2.209-1.791-4-4-4H64.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBD54"
    },
    d: "M161.223,247.477v228.7h26.905c2.209,0,4-1.791,4-4v-220.7c0-2.209-1.791-4-4-4H161.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3BB3E3"
    },
    d: "M260.121,270.141v206.036h26.905c2.209,0,4-1.791,4-4V274.141c0-2.209-1.791-4-4-4H260.121z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50536E"
    },
    d: "M45.843,105.601h226.64c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5H45.843    c-4.143,0-7.5,3.358-7.5,7.5S41.7,105.601,45.843,105.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50536E"
    },
    d: "M272.482,124.94H45.843c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h226.64    c4.143,0,7.5-3.358,7.5-7.5S276.625,124.94,272.482,124.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50536E"
    },
    d: "M272.482,159.28H45.843c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h226.64    c4.143,0,7.5-3.358,7.5-7.5S276.625,159.28,272.482,159.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#50536E"
    },
    d: "M103.615,193.619H45.843c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h57.772    c4.143,0,7.5-3.358,7.5-7.5S107.758,193.619,103.615,193.619z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.7994 258.0698)",
    style: {
      fill: "#50536E"
    },
    cx: 297.118,
    cy: 163.799,
    rx: 163.799,
    ry: 163.799
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5FCFF"
    },
    d: "M391.088,257.769c-51.815,51.815-136.124,51.815-187.94,0s-51.815-136.124,0-187.94   s136.124-51.815,187.94,0S442.903,205.954,391.088,257.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71F6FC"
    },
    d: "M391.088,69.829c-29.836-29.836-70.446-42.487-109.423-37.963   c28.712,3.333,56.538,15.984,78.517,37.963c51.815,51.815,51.815,136.124,0,187.94c-21.979,21.979-49.805,34.63-78.517,37.963   c38.977,4.524,79.587-8.127,109.423-37.963C442.903,205.954,442.903,121.644,391.088,69.829z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIcon);
export default __webpack_public_path__ + "static/media/ExploreIcon.7beeae5f.svg";
export { ForwardRef as ReactComponent };